export { default as calls } from './callsC.js';
export { default as compact } from "./compactC.js";
export { default as drop } from "./dropC.js";
export { default as every } from './everyC.js';
export { default as filter } from './filterC.js';
export { default as find } from './findC.js';
export { default as head } from './headC.js';
export { default as map } from './mapC.js';
export { default as mapEntries } from './mapEntriesC.js';
export { default as object, default as fromEntries } from "./objectC.js";
export { default as race } from "./raceC.js";
export { default as reduce } from './reduceC.js';
export { default as some } from './someC.js';
export { default as tail } from './tailC.js';
export { default as take1 } from './take1C.js';
export { default as takeAll } from './takeAllC.js';
export { default as take } from './takeC.js';
export { default as takeRace } from "./takeRaceC.js";